/**
 * Icônes Heroicons v1 (outline 24px) inline — paths copiés depuis heroicons.com.
 * Chaque fonction retourne un <span aria-hidden> contenant le SVG.
 * La couleur est contrôlée via la propriété CSS `color` (currentColor).
 */

// Contenu de confiance — paths SVG hardcodés, pas d'input utilisateur
function makeSvgIcon(paths) {
  const wrapper = document.createElement('span');
  wrapper.className = 'sw-icon';
  wrapper.setAttribute('aria-hidden', 'true');
  wrapper.innerHTML =
    `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ` +
    `stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ` +
    `width="24" height="24">${paths}</svg>`;
  return wrapper;
}

export const iconEye = () => makeSvgIcon(
  `<path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>` +
  `<path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7` +
  `-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>`
);

export const iconEyeSlash = () => makeSvgIcon(
  `<path d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7` +
  `a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242` +
  `M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59` +
  `m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7` +
  `a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>`
);

export const iconRefresh = () => makeSvgIcon(
  `<path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>`
);

export const iconQuestionCircle = () => makeSvgIcon(
  `<path d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3` +
  ` 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01` +
  `M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>`
);
